export const LOCATIONS_FEATURE_KEY = 'locations';
